import { RefObject } from 'react';
import { Currency } from '../transactions-sidepanels/types';

export enum InputType {
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
  TIME = 'time',
}

export enum InputSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface InputProps {
  title?: string;
  placeholder: string;
  type?: InputType;
  size?: InputSize;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  name: string;
  className?: string;
  maxLength?: number;
  value?: string | number;
  error?: string;
  prefix?: string | React.JSX.Element;
  suffix?: string | React.JSX.Element;
  labelClassName?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  tabIndex?: number;
  inputRef?: RefObject<HTMLInputElement | null>;
  amountInput?: boolean;
  currency?: Currency;
  min?: number;
  max?: number;
  prefixClassName?: string;
  suffixClassName?: string;
  withoutMinDigits?: boolean;
  withCopy?: boolean;
  withShowButton?: boolean;
}
